import { Flex, color, spacing, typography } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

export const SocialProofAccentContainer = styled(Flex)`
    height: 100%;
    width: 100%;
`;

export const SocialProofBanner = styled(Flex)`
    position: absolute;
    bottom: ${spacing(7)};

    ${typography('body.small.default')}

    gap: ${spacing(5)};

    opacity: 0.6;
`;

export const SocialProofLogosContainer = styled(Flex)`
    gap: ${spacing(5)};
    color: ${color('background.surface.inverse')};
`;
